












import { Vue, Component, Prop } from 'nuxt-property-decorator'
import { computed, defineComponent, useStore } from '@nuxtjs/composition-api'
import Footer from '@/components/Footer/index.vue'
import FooterNew from '@/components/Footer/new-design'

@Component
class FooterSection extends Vue {
  static options: any
  @Prop() readonly firstSection: Boolean = true
  @Prop() readonly secondSection: Boolean = true
  @Prop() readonly copyrightSection: Boolean = true
}
export default defineComponent({
  name: 'FooterSection',
  components: {
    FooterNew,
    Footer,
  },
  props: FooterSection.options.props,
  setup() {
    const store = useStore()
    const isNewDesign = computed(
      () => store.getters['settings/getHeaderFooterNewDesign']
    )
    return { isNewDesign }
  },
})
